import { Box, styled } from '@mui/material';
import { kiwiGreen, spaceCadet } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: 16,
  columnGap: 32,
  '& > .MuiBox-root': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    '& > .MuiBox-root.timezone': {
      display: 'flex',
      gap: 4,
      alignItems: 'center',
      '& > .MuiTypography-caption': {
        color: spaceCadet[400],
        fontWeight: 600,
      },
    },

    '& > .MuiBox-root.user': {
      display: 'flex',
      gap: 4,

      '& .MuiAvatar-root': {
        fontSize: 14,
        width: 24,
        height: 24,
      },
      '& svg': {
        width: 24,
        height: 24,
        display: 'block',
        color: spaceCadet[400],
      },

      '& .MuiTypography-body1': {
        marginTop: 0,
        fontWeight: 600,
      },
    },
    '& .MuiTypography-subtitle2': {
      color: spaceCadet[400],
      fontSize: 14,
      lineHeight: '16px',

    },
  },
  '& .MuiTypography-body1': {
    maxWidth: 150,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  '& .MuiBox-root.external-call-box': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    '& > .MuiBox-root': {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& .MuiBox-root.copy-box': {
        display: 'flex',
        alignItems: 'flex-end',
        gap: 2,
        '& > .MuiButton-root': {
          padding: 0,
          minWidth: 0,
          '& svg': {
            fontSize: '1rem',
          },
        },
      },
    },
  },
  '& .MuiAlert-root': {
    backgroundColor: kiwiGreen[100],
    '& .MuiAlert-icon': {
      color: kiwiGreen[600],
    },
    '& .MuiAlert-message': {
      color: kiwiGreen[600],
    },
    '& .MuiAlert-action svg': {
      color: kiwiGreen[600],
    },
  },
});

export default StyledBox;
